<template>
  <div class="content-view">
    <v-row class="ma-0">
      <v-col class="mb-1 label d-sr-only">
        {{ text }}
      </v-col>
      <v-col class="mb-1">
        <div class="avatar-wrapper" @click="chooseAvatar" :class="{edit:edit}">
          <img v-if="typeof src !== 'undefined'" :src="src" class="avatar"/>
          <div v-if="typeof src === 'undefined'" class="default-avatar-background">
            <PersonIcon class="default-avatar"/>
          </div>
          <PictureIcon class="picture-icon" v-if="edit"/>
        </div>
      </v-col>
    </v-row>
    <input type="file" ref="fileElem" multiple accept="image/*" style="display:none" @change="handleFiles">
  </div>
</template>

<script>
import PictureIcon from "@/components/icons/PictureIcon";
import {toRefs, watch} from "@vue/composition-api";
import PersonIcon from "@/components/icons/PersonIcon";

export default {
  name: "AvatarEditorComponent",
  components: {PersonIcon, PictureIcon},
  props: {
    text: String,
    src: String,
    edit: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {refs, emit}) {

    let changeListenerActive = true

    function handleFiles() {
      let fileObj = refs['fileElem'].files[0]
      if (typeof fileObj !== 'undefined' && changeListenerActive) emit('avatarFileSelected', fileObj)
    }

    function chooseAvatar() {
      if (props.edit) refs['fileElem'].click()
    }

    const {src} = toRefs(props)
    watch(src, () => {
      changeListenerActive = false
      refs['fileElem'].value = ''
      changeListenerActive = true
    })

    return {handleFiles, chooseAvatar}
  }
}
</script>

<style scoped lang="scss">
.content-view {
  max-height: 100%;
  overflow-y: auto;

  .label {
    color: #878787;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    width: 140px;
    display: flex;
    flex: 0 0 140px;
    align-items: flex-end;
  }

  .avatar-wrapper {
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    position: relative;
    margin: auto;
    width: 91px;
    height: 91px;

    &.edit {
      cursor: pointer;

      .default-avatar-background,
      .avatar {
        opacity: 0.3;
      }
    }

    .avatar {
      width: 91px;
    }

    .default-avatar-background {
      display: flex;
      align-items: center;
      width: 100%;
      background-color: #5AB78E;
      border-radius: 50%;

      .default-avatar {
        margin: auto;
        height: 50%;
        width: 50%;
      }
    }

    .picture-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
